import React, {useEffect, useRef, Suspense, useState} from 'react';
import Sidebar from "../components/Sidebar";
import Mailbox from "../components/Mailbox";
import {Helmet} from "react-helmet";

import {useQuery} from "react-query";
import axiosInstance from "../libs/axiosInstant";

import {useDispatch, useSelector} from "react-redux";
import {setConfig, setLabels} from "../stores/mailbox";
import pushSubscriber from "../libs/PushSubscriber";

const MailContent = React.lazy(() => import('../components/MailContent'));
const ComposeMessage = React.lazy(() => import('../components/ComposeMessage'));
function MessageCenter() {

    const dispatch = useDispatch()

    const hasSubscribed = useRef(false);
    useEffect(() => {
        if (!hasSubscribed.current) {
            pushSubscriber();
            hasSubscribed.current = true; // Set to true to prevent future calls
        }
    }, [])

    const fetchConfig = async () => {
        const {data} = await axiosInstance.get('/inbox/settings');
        dispatch(setConfig({config: data}));
        return data;
    }
    const fetchLabels = async () => {
        const {data} = await axiosInstance.get('/inbox/labels');
        dispatch(setLabels({labels: data}));
        return data;
    }
    const configQuery = useQuery('config', fetchConfig)
    const {isLoading, isError, error, isSuccess} = useQuery('labels', fetchLabels)

    if (isLoading || configQuery.isLoading) {
        return <div className="loading-container">
            <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
            <strong role="status">Loading...</strong>
        </div>
    }
    if (isError) {
        return <div className="alert alert-danger">{error}</div>
    }

    if (isSuccess && configQuery.isSuccess) return <div>
        {configQuery?.data?.option &&
            <Helmet>
                <title>{configQuery.data.option.site_title} - Message Center</title>
                <link rel="icon" href={configQuery.data.option.favicon}/>
                <link rel="apple-touch-icon" href={configQuery.data.option.favicon}/>
            </Helmet>
        }
        <Sidebar/>
        <Mailbox/>
        <Suspense fallback={<></>}>
            <MailContent/>
            <ComposeMessage/>
        </Suspense>
    </div>

}

export default MessageCenter;
